<script setup>
import { Handle, Position, useNode } from '@vue-flow/core';
import { useI18n } from 'vue-i18n';
import { useNodeAudience } from '../../composables/useNodeAudience.js';

const props = defineProps({
  data: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
});

const { t } = useI18n();
const { id } = useNode();
const audienceCount = useNodeAudience(id);

const fieldCount = () => (props.data.fields ?? []).filter(f => f.key).length;
</script>

<template>
  <div
    class="flow-node w-[180px] rounded-xl overflow-hidden shadow-md border-2 transition-all"
    :class="selected ? 'border-n-teal-8' : 'border-transparent'"
  >
    <Handle type="target" :position="Position.Top" />
    <div class="flex items-center gap-2 px-3 py-2 bg-n-teal-9 text-white rounded-t-xl">
      <span class="i-lucide-scan-text size-4 shrink-0" />
      <span class="text-xs font-semibold truncate flex-1">{{ data.name || t('FLOW_BUILDER.NODES.EXTRACT_DATA.TITLE') }}</span>
      <span v-if="audienceCount !== null" class="text-[9px] bg-white/20 rounded-full px-1.5 py-0.5 font-medium tabular-nums shrink-0">
        {{ audienceCount }}
      </span>
    </div>
    <div class="px-3 py-2 bg-n-solid-1 text-n-slate-12 text-xs">
      <span v-if="fieldCount() > 0">{{ t('FLOW_BUILDER.NODES.EXTRACT_DATA.FIELDS_COUNT', fieldCount()) }}</span>
      <span v-else class="text-n-slate-9">{{ t('FLOW_BUILDER.NODES.EXTRACT_DATA.NO_FIELDS') }}</span>
    </div>
    <Handle type="source" :position="Position.Bottom" />
  </div>
</template>
